import React, { useEffect, useState } from 'react';
import classes from "./SelectCaptainAndViceCaptain2.module.css";
import { FaArrowLeft } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import { editUserTeamApi, saveUserTeamApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment-timezone";
import { toast } from 'react-toastify';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { useTranslation } from 'react-i18next';

// Group players by position for display
const POSITION_ORDER = ["Goalkeeper", "Defender", "Midfielder", "Attacker"];

const SelectCaptainAndViceCaptain2 = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [matchDetails, setMatchDetails] = useState(null);
    const [time, setTime] = useState(null);
    const [loading, setLoading] = useState(false);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const dispatch = useDispatch();

        const { selectedLanguage } = useSelector((state) => state.languageSlice);
    

    const { t } = useTranslation();


    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                navigate("/home");
                toast.info(t("69"));
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();
            setTime(`${hours}h ${minutes}m ${seconds}s`);
        } catch (error) {
            console.log(error, 'error--');
        }
    };

    useEffect(() => {
        if (matchDetails) {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [matchDetails]);

    useEffect(() => {
        setSelectedPlayers(location?.state?.selectedPlayers || []);
        setMatchDetails(location?.state?.matchDetails);
    }, [location.state]);

    const handlePlayerSelect = (selectedPlayer, type) => {
        const updatedPlayers = selectedPlayers.map(player => {
            if (player.id === selectedPlayer.id) {
                return {
                    ...player,
                    captain: type === "captain" ? !player.captain : false,
                    viceCaptain: type === "viceCaptain" ? !player.viceCaptain : false,
                };
            } else {
                return {
                    ...player,
                    captain: type === "captain" ? false : player.captain,
                    viceCaptain: type === "viceCaptain" ? false : player.viceCaptain,
                };
            }
        });
        setSelectedPlayers(updatedPlayers);
    };

    const saveTeamHandler = async () => {
        try {
            setLoading(true);
            if (location?.state?.edit) {
                await editUserTeamApi(
                    matchDetails?.match_fixture_id, selectedPlayers,
                    matchDetails?.match_date_time,
                    matchDetails?.match_venue_name, matchDetails?.match_venue_city,
                    matchDetails?.league_id, matchDetails?.league_name, matchDetails?.league_image,
                    matchDetails?.home_team_id, matchDetails?.home_team_name, matchDetails?.home_team_image,
                    matchDetails?.away_team_id, matchDetails?.away_team_name, matchDetails?.away_team_image,
                    userDetails?.token
                );
            } else {
                await saveUserTeamApi(
                    matchDetails?.match_fixture_id, selectedPlayers,
                    matchDetails?.match_date_time,
                    matchDetails?.match_venue_name, matchDetails?.match_venue_city,
                    matchDetails?.league_id, matchDetails?.league_name, matchDetails?.league_image,
                    matchDetails?.home_team_id, matchDetails?.home_team_name, matchDetails?.home_team_image,
                    matchDetails?.away_team_id, matchDetails?.away_team_name, matchDetails?.away_team_image,
                    userDetails?.token
                );
            }
            setLoading(false);
            navigate("/fantasy-game", {
                state: { match_fixture_id: matchDetails?.match_fixture_id }
            });
        } catch (error) {
            if (error?.response?.status === 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                setLoading(false);
                toast.error(t("20"));
            }
        }
    };

    const hasCaptain = selectedPlayers.filter(d => d?.captain).length > 0;
    const hasViceCaptain = selectedPlayers.filter(d => d?.viceCaptain).length > 0;
    const canSave = hasCaptain && hasViceCaptain;

    // Group players by position
    const grouped = POSITION_ORDER.map(pos => ({
        position: pos,
        players: (selectedPlayers || []).filter(p => p.position === pos),
    })).filter(g => g.players.length > 0);

    const POSITION_LABELS = {
        Goalkeeper: "Goalkeeper",
        Defender: "Defenders",
        Midfielder: "Midfielders",
        Attacker: "Strikers",
    };

    const POSITION_LABELS_FR = {
        Goalkeeper: "Gardien de but",
        Defender: "Défenseurs",
        Midfielder: "Milieux de terrain",
        Attacker: "Attaquants",
    };

    return (
        <div className={classes.page}>
            <div className={classes.pageInner}>

                {/* ── Sticky header ── */}
                <div className={classes.header}>

                    {/* Top bar */}
                    <div className={classes.header_nav}>
                        <div className={classes.header_nav_container}>
                            <button type="button" className={classes.back_button} onClick={() => navigate(-1)}>
                                <FaArrowLeft className={classes.back_icon} />
                            </button>
                            <div className={classes.header_text_container}>
                                <span className={classes.header_text}>
                                    {location?.state?.edit ? t("70") : t("71")} {t("72")}
                                </span>
                                {time && (
                                    <span className={classes.header_timer}>
                                        ⏱ {time} {t("73")}
                                    </span>
                                )}
                            </div>
                        </div>
                        <button type="button" className={classes.header_button}>
                            {t("74")}
                        </button>
                    </div>

                    {/* Sub-title */}
                    <div className={classes.info_container}>
                        <span className={classes.info_text}>{t("75")} &amp; {t("76")}</span>
                    </div>

                    {/* Points info */}
                    <div className={classes.point_info}>
                        <div className={classes.point_container}>
                            <div className={classes.point_sub_container}>
                                <span className={classes.point_type}>C</span>
                            </div>
                            <div className={classes.point_description}>
                                <span className={classes.point_text_info}>{t("77")}</span>
                                <span className={classes.point_text}>{t("78")}</span>
                            </div>
                        </div>
                        <div className={classes.point_container}>
                            <div className={classes.point_sub_container_vc}>
                                <span className={classes.point_type_vc}>VC</span>
                            </div>
                            <div className={classes.point_description}>
                                <span className={classes.point_text_info}>{t("79")}</span>
                                <span className={classes.point_text}>{t("80")}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Players list ── */}
                <div className={classes.players_list}>
                    {grouped.map(({ position, players }) => (
                        <React.Fragment key={position}>
                            <div className={classes.position_group_label}>
                                {selectedLanguage=="0" ? POSITION_LABELS[position] : POSITION_LABELS_FR[position]}
                            </div>
                            {players.map((item, index) => (
                                <div className={classes.player_container} key={index}>
                                    <div className={classes.player_details}>
                                        <div className={classes.player_image_container}>
                                            <img
                                                src={item?.photo}
                                                alt={item?.name}
                                                className={classes.player_image}
                                            />
                                        </div>
                                        <div className={classes.player_details_container}>
                                            <span className={classes.player_name}>{item?.name}</span>
                                            <span className={classes.player_team_name}>{item?.teamName}</span>
                                        </div>
                                    </div>

                                    <div className={classes.buttons_container}>
                                        <button
                                            type="button"
                                            className={`${classes.captain_button} ${item?.captain ? classes.active : ''}`}
                                            onClick={() => handlePlayerSelect(item, "captain")}
                                        >
                                            C
                                        </button>
                                        <button
                                            type="button"
                                            className={`${classes.vice_captain_button} ${item?.viceCaptain ? classes.active : ''}`}
                                            onClick={() => handlePlayerSelect(item, "viceCaptain")}
                                        >
                                            VC
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </React.Fragment>
                    ))}
                </div>

                {/* ── Sticky Save button ── */}
                <div className={classes.nextWrap}>
                    <div className={classes.nextInner}>
                        <span className={classes.nextCount}>
                            {hasCaptain ? t("81") : t("82")}
                            <span className={classes.nextCountHighlight}>
                                {hasViceCaptain ? t("83") : t("84")}
                            </span>
                        </span>
                        <button
                            type="button"
                            disabled={loading || !canSave}
                            className={`${classes.next_button} ${canSave ? classes.active : ''}`}
                            onClick={() => { if (canSave && !loading) saveTeamHandler(); }}
                        >
                            {loading
                                ? <SmallLoader />
                                : location?.state?.edit ? t("85") : t("86")
                            }
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SelectCaptainAndViceCaptain2;